import { Redirect, useLocation } from "react-router-dom";

import { CMP_ROOT_URL, PARTNERS_URL } from "@/core/urls";

export default function RedirectToNewCmpUrlFromOld() {
  const location = useLocation();

  const newPath = location.pathname.replace(PARTNERS_URL, CMP_ROOT_URL);

  const fullNewUrl = `${newPath}${location.search}${location.hash}`;

  return <Redirect to={fullNewUrl} />;
}
